import { toast } from '../util/decorators'
import api from './api'
import BaseService from './BaseService'

export default class LiveService extends BaseService {
    constructor() {
        super({
        })
    }

    @toast()
    async loadList() {
        return await api.lives.getLiveRooms(1, 20)
    }

    @toast()
    async getDetail(id) {
        return await api.lives.getLiveDetail(id)
    }

    @toast()
    async postVote(id) {
        return await api.lives.postVote(id)
    }

    postHit(ac, id) {
        return api.lives.postHit(ac, id)
    }
}




// WEBPACK FOOTER //
// ./src/service/LiveService.js